// Polyfills for older browsers (Safari 9, etc.)
import 'core-js/stable';
import 'whatwg-fetch';

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// PWA Install prompt - capture it globally as soon as possible
window.deferredPrompt = null;

window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later
  window.deferredPrompt = e;
  console.log('PWA: Install prompt ready');
});

window.addEventListener('appinstalled', () => {
  window.deferredPrompt = null;
  console.log('PWA: App was installed');
});

// Check for createRoot support (React 18+)
const rootElement = document.getElementById("root");

if (ReactDOM.createRoot) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  // Fallback for older React DOM (shouldn't happen but just in case)
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    rootElement
  );
}

// Register service worker for PWA support (only if supported)
if ('serviceWorker' in navigator) {
  serviceWorkerRegistration.register();
}
